/**
 * Module-level session store.
 *
 * With HttpOnly-cookie authentication the JWT is no longer readable by JS, so the
 * user/role/expiry data that used to be decoded from the token now comes from the
 * backend (`GET /api/v1/auth/me`, the login response, the refresh response) and is
 * kept here. `AuthContext` keeps it in sync with React state; components that render
 * deep inside the tree (Menu, Admin, project forms, ...) read it via the helpers
 * without having to thread the context down.
 */
let session = {user: null, role: null, expiresAt: null};

export const setSession = next => {
  session = next && next.user ? next : {user: null, role: null, expiresAt: null};
};

export const getSession = () => session;

export const clearSession = () => {
  session = {user: null, role: null, expiresAt: null};
};
